module.exports = __webpack_public_path__ + "media/images/pic/hero-93bbcd8bdf9e5afd0f97bf3e7cc50aee.svg";